module.exports = {
  text: `Такая порочность. Такая ужасающая жестокость. Они — мерзкий яд, отравляющий всех эльфов`,
  author: `Нэлар Отэмвэлл, эльфийский жрец Кореллона Ларетиана`,
}
